import { render, staticRenderFns } from "./StreakNoUser.vue?vue&type=template&id=a5036e2a&scoped=true&"
import script from "./StreakNoUser.vue?vue&type=script&lang=ts&"
export * from "./StreakNoUser.vue?vue&type=script&lang=ts&"
import style0 from "./StreakNoUser.vue?vue&type=style&index=0&id=a5036e2a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a5036e2a",
  null
  
)

export default component.exports